import { Component, OnInit } from '@angular/core'
import { MetaService } from 'src/app/shared/services/meta.service'

import { Aggregation } from '../../shared/interfaces/visualizations/aggregation.interface'
import { VisualizationService } from '../../shared/services/visualization.service'
import { ContentService } from '../../shared/services/content.service'
import {
  DynamicContent,
  DynamicContentItem
} from '../../shared/interfaces/dynamic-content.interface'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  loadingAggregations: boolean = false
  aggregations: Aggregation[]
  otherAggregation: Aggregation

  additionalResources: DynamicContentItem[]

  constructor(
    private visualizationService: VisualizationService,
    private contentService: ContentService,
    private metaService: MetaService
  ) {}

  ngOnInit(): void {
    this.loadingAggregations = true
    this.visualizationService.listMainVisualizations().then(
      (visualizationRes: {
        aggregations: Aggregation[]
        otherAggregation: Aggregation
      }) => {
        this.loadingAggregations = false
        this.aggregations = visualizationRes.aggregations
        this.otherAggregation = visualizationRes.otherAggregation
      },
      (err) => {
        this.loadingAggregations = false
      }
    )

    this.contentService
      .getDynamicContent()
      .then((dynamicContent: DynamicContent) => {
        this.additionalResources = dynamicContent.homePageContent
      })

    this.metaService.setTags('home')
  }
}
